import React from 'react';

import { List } from '@common/typescript/objects/List';

import { rest } from '@app/components/Api';
import {
	aftercareEmbedText,
	aftercareMastheadText,
	aftercareRichText1,
	aftercareRichText2,
} from '@app/components/Pages/Services/Aftercare/aftercareContent';
import FaqBlock from '@app/components/UI/FaqBlock/FaqBlock';
import FaqBlockHeaderSm from '@app/components/UI/FaqBlock/FaqBlockHeaderSm';
import HelmetProvider from '@app/components/UI/HelmetProvider/HelmetProvider';
import LinkBlockSmall from '@app/components/UI/LinkBlock/LinkBlockSmall';
import Masthead from '@app/components/UI/MastHead/Masthead';
import RichText from '@app/components/UI/RichText/RichText';
import VideoEmbed from '@app/components/UI/VideoEmbed/VideoEmbed';
import { LinkBlockItemActive } from '@app/objects/LinkBlockItem';
import { Questions } from '@app/objects/Questions';

const Aftercare = () => {
	const [questions, setQuestions] = React.useState<Array<Questions>>([]);

	React.useEffect(() => {
		rest.get<List<Questions>>('v1/faq/aftercarePage').then((res) => setQuestions(res.list));
	}, []);

	const linkItems:Array<LinkBlockItemActive> = [
		{
			path: '/our-services/veterinary-hospice',
			name: 'Veterinary Hospice',
		},
		{
			path: '/our-services/in-home-euthanasia',
			name: 'In-Home Euthanasia',
		},
		{
			path: '/our-services/aftercare',
			name: 'Aftercare',
			active: true,
		},
		{
			path: '/our-services/telehospice',
			name: 'Telehospice',
		},
		{
			path: '/our-services/pet-loss-support',
			name: 'Pet Loss Support',
		},
	];

	return (
		<HelmetProvider>
			<div className="aftercare our-services">
				<Masthead
					title="Cremation & Aftercare"
					imageSrc={require('@app/content/aftercare.png')}
					text={aftercareMastheadText}
					quoteAuthor="Samantha, Dog Mom"
					imageAlt="Pet aftercare options"
				/>
				<VideoEmbed text={aftercareEmbedText} />
				<RichText title="Cremation and aftercare options include:" text={aftercareRichText1} />
				<RichText title="What to expect from cremation" text={aftercareRichText2} />
				<div className="care-coordinator__faq">
					<div className="care-coordinator__faq-content">
						<FaqBlockHeaderSm title="You might find yourself asking..." btnText="View all FAQ" clickUrl="/faq" />
						<FaqBlock questions={questions} />
					</div>
				</div>
				<LinkBlockSmall items={linkItems} />
			</div>
		</HelmetProvider>
	);
};

export default Aftercare;
